import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from "@angular/material";

@Component({
  selector: 'app-archive-list',
  templateUrl: './archive-list.component.html',
  styleUrls: ['./archive-list.component.css']
})
export class ArchiveListComponent implements OnInit {
  tabList: any[];
  public loading = false;
  public storeList: Array<any> = [];
  public limit=500;
  public page = 1;
  constructor(public dialog: MatDialog,private CommonService: CommonService) {
    this.tabList = [
      { key: '/stores', val: 'Store', cls: '' },
      { key: '/stores/order', val: 'Order', cls: '' },
      { key: '/stores/archive-list', val: 'Archive', cls: 'active' }

    ]
   }

  ngOnInit() {
    this.getStoreData();
  }

  getStoreData = function () {
    this.loading = true;
    this.Options = {
      shop_id: localStorage.getItem("userID"),
      limit: this.limit,
      page:this.page,
      archive_status:'1'      
    };    
    
    this.CommonService.apiService(
      "POST",
      "store/list",
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.storeList = response.data.records;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  moveToStore = function (storeId,index) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to activate this store",
        manageData: { store_id: storeId, dialogName: "Move to Store" }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.store_id) {
        this.loading = true;
        this.Options = {
          id:result.store_id,
          shop_id: localStorage.getItem("userID")      
        };   
        this.CommonService.apiService(
          "POST",
          "store/movetostore",
          this.Options
        ).subscribe(
          (response: any) => {
            if (response.status === true) {
              this.loading = false;
              this.storeList.splice(index,1);         
            }
          },
          err => {
            this.loading = false;
            console.log(err);
          }
        );
      }
    });
  }

  removeString(name) {
    return name.replace('del_', '');
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/archive-list/archive-list.component.ts